import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Button, CircularProgress, Stack } from '@mui/material';
import { _ } from '/@/locale';
import type { RecommendationActionsProps } from '/@/types/recommendation-create';

function RecommendationActions({ steps, activeStep, setActiveStep, isLoading }: RecommendationActionsProps) {
    return (
        <Stack
            direction='row'
            p={3}
            justifyContent='space-between'
            borderTop={'1px solid lightgray'}
            sx={{ position: 'absolute', width: '100%', bottom: 0, background: 'white' }}
        >
            <Button
                variant='outlined'
                color='secondary'
                onClick={
                    steps[activeStep]?.onClickBack
                        ? steps[activeStep]?.onClickBack
                        : () => setActiveStep(activeStep - 1)
                }
                disabled={isLoading || steps[activeStep]?.onClickBackDisabled?.()}
            >
                <Stack direction='row' spacing={1} alignItems='center'>
                    <ArrowBackIosIcon />
                    {steps[activeStep]?.onClickBackText ? steps[activeStep]?.onClickBackText : _('Atrás')}
                </Stack>
            </Button>
            <Button
                variant='contained'
                color='secondary'
                onClick={
                    steps[activeStep]?.onClickNext
                        ? steps[activeStep]?.onClickNext
                        : () => setActiveStep(activeStep + 1)
                }
                disabled={isLoading || steps[activeStep]?.onClickNextDisabled?.()}
            >
                <Stack direction='row' spacing={1} alignItems='center' data-testid='recommendation-actions-next-button'>
                    {isLoading
                        ? _('Cargando')
                        : steps[activeStep]?.onClickNextText
                          ? steps[activeStep]?.onClickNextText
                          : _('Siguiente')}
                    {isLoading ? <CircularProgress size={16} color='inherit' /> : <ArrowForwardIosIcon />}
                </Stack>
            </Button>
        </Stack>
    );
}

export default RecommendationActions;
